(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.shell:mxShellLeftSidebar
	 * @module mx.shell
	 * @requires <a href="https://docs.angularjs.org/api/ng/service/$document" target="_blank">$document</a>
	 * @requires <a href="https://docs.angularjs.org/api/ng/service/$timeout" target="_blank">$timeout</a>
	 * @requires <a href="https://material.angularjs.org/latest/api/service/$mdSidenav" target="_blank">$mdSidenav</a>
	 * @requires {@ref mx.internationalization mx.internationalization}
	 * @requires {@ref mx.shell.NavigationService mx.shell.NavigationService}
	 * @requires {@ref mx.shell.EventService mx.shell.EventService}
	 * @requires {@ref mx.shell.NavigationManager mx.shell.NavigationManager}
	 * @requires {@ref mx.shell.Config mx.shell.Config}
	 * @requires {@ref mx.app.DeviceService mx.components.DeviceService}
	 * @description
	 * Side panel that contains navigation items
	 * @usage <mx-shell-nav layout="column"></mx-shell-nav>
	 */

	angular.module('mx.shell').component('mxShellLeftSidebar', {
		controller: MxShellLeftSidebarCtrl,
		controllerAs: 'vm',
		templateUrl: 'components/mx-shell-left-sidebar/mx-shell-left-sidebar.html',
	});

	MxShellLeftSidebarCtrl.$inject = [
		'$timeout',
		'$mdSidenav',
		'mx.internationalization',
		'mx.shell.NavigationService',
		'mx.shell.EventService',
		'mx.shell.NavigationManager',
		'mx.shell.Config',
		'mx.app.DeviceService',
		'$document',
		'$scope',
		'$q',
		'$element',
		'$window',
		'mx.shell.KeyboardNavigationService',
		'mx.shell.LeftSidebarService',
		'mx.shell.InternationalizationService',
	];

	function MxShellLeftSidebarCtrl(
		$timeout,
		$mdSidenav,
		i18n,
		navigationService,
		eventService,
		navigationManager,
		config,
		deviceService,
		$document,
		$scope,
		$q,
		$element,
		$window,
		keyboardNavigationService,
		leftSidebarService,
		i18nService
	) {
		var vm = this;
		var _cssHtmlEl;
		var navbarPlaceholder;
		var _enableNavResizeMode = false;
		var mxShellNav;
		var collapsedWidth = 0;
		var minNavWidth = 200;
		var HALF_DRAGSTRAP_WIDTH = 3;

		var getStoredNavWidth = function () {
			var width = localStorage && parseInt(localStorage.getItem('mxShellNavWidth'), 10);

			return width || 220;
		};

		var navWidth = getStoredNavWidth();

		var RAF = (function () {
			return (
				$window.requestAnimationFrame ||
				$window.webkitRequestAnimationFrame ||
				$window.mozRequestAnimationFrame ||
				$window.oRequestAnimationFrame ||
				$window.msRequestAnimationFrame ||
				function (callback) {
					$timeout(callback);
				}
			);
		})();

		vm.close = closeNav;

		// TODO: rework resizing with `mxComponent:mxResizable` somehow
		vm.startNavResize = startNavResize;
		vm.stopNavResize = stopNavResize;

		vm.showNavigation = true;

		vm.leftSidebarService = leftSidebarService;
		vm.NavigationManager = navigationManager;
		vm.deviceService = deviceService;
		vm.onTabClick = onTabClick;

		vm.$onInit = function () {
			vm.isVisible = true;
			init();
			initWatchers();
			registerHotkeys();
			initAria();
		};

		vm.$postLink = function () {
			$document.on('mouseup', vm.stopNavResize);
		};

		eventService.subscribeTo(
			mx.shell.EventCodes.DisplayModeChanged,
			function (event, newMode) {
				vm.isVisible = newMode === mx.shell.DisplayMode.Normal;
				var styleValue = vm.isVisible ? '' : '0 !important';

				styleValue = 'left: ' + styleValue + '; top: ' + styleValue + ';';
				$('.mx-main-content-zone-container').attr('style', styleValue);
			},
			$scope
		);

		var _debouncedLayoutChangeDispatcher = $.debounce(500, function () {
			eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged);
		});

		return vm;

		function init() {}

		function initWatchers() {
			$scope.$watch('vm.leftSidebarService.isVisible', function (res) {
				if (res) {
					RAF(function () {
						setNavSizes(vm.NavigationManager.collapsedMode ? collapsedWidth : navWidth);
					});
				} else {
					removeSizes();
				}
			});

			$scope.$watch('vm.NavigationManager.collapsedMode', function (newVal, oldVal) {
				if (vm.NavigationManager.collapsedMode !== undefined) {
					setNavSizes(vm.NavigationManager.collapsedMode ? collapsedWidth : navWidth, true);
					vm.NavigationManager.collapsedState = vm.NavigationManager.collapsedMode;
				}

				if ((!newVal && oldVal) || (newVal && !oldVal)) {
					vm.NavigationManager.__navAnimationInProgress = true;
					$timeout(function () {
						vm.NavigationManager.__navAnimationInProgress = false;
					}, 500);
				}
			});

			$scope.$watch('vm.NavigationManager.collapsedState', function (newVal, prevVal) {
				if (newVal === true && prevVal === false) {
					setNavSizes(collapsedWidth, true);
				}
				if (newVal === false && prevVal === true) {
					setNavSizes(navWidth, true);
				}
			});
		}

		function closeNav() {
			$mdSidenav('mx-shell-left-sidebar').close();
		}

		function startNavResize() {
			var doc = $document[0],
				html = angular.element(doc.documentElement),
				body = angular.element(doc.body);

			_enableNavResizeMode = true;
			$document.on('mousemove', handleNavResize);

			html.addClass('is-resizing');

			if (navbarPlaceholder) {
				navbarPlaceholder.show();
			} else {
				navbarPlaceholder = angular.element('<div class="navbar-placeholder"/>');

				navbarPlaceholder.prependTo(body);
			}
		}

		function stopNavResize() {
			if (!_enableNavResizeMode) {
				return;
			}

			_enableNavResizeMode = false;
			$document.off('mousemove', handleNavResize);

			if (localStorage) {
				localStorage.setItem('mxShellNavWidth', navWidth);
			}

			angular.element($document[0].documentElement).removeClass('is-resizing');

			if (navbarPlaceholder) {
				navbarPlaceholder.trigger('mouseleave').hide();
			}

			setNavSizes(navWidth, vm.NavigationManager.collapsedMode);
		}

		function handleNavResize(event) {
			if (!_enableNavResizeMode) {
				return;
			}

			var windowWidth = mx.components.Utils.windowSize().width;

			var minWidth = minNavWidth;
			var maxWidth = windowWidth;

			RAF(function () {
				const logicalClientX = i18nService.currentLanguage.isRightToLeft ? windowWidth - event.clientX : event.clientX;
				navWidth = logicalClientX - HALF_DRAGSTRAP_WIDTH;
				if (navWidth > maxWidth) {
					navWidth = maxWidth;
				}
				if (navWidth < minWidth) {
					navWidth = minWidth;
				}

				navbarPlaceholder.css({ width: navWidth + 2 * HALF_DRAGSTRAP_WIDTH });
			});
		}

		// TODO: debug why this method is called times on app init and switching Navigation (open/closed)
		function setNavSizes(navWidth, useAnimation) {
			var navWidthCss = navWidth + 'px';
			var cssHtml;

			mxShellNav = mxShellNav && mxShellNav[0] ? mxShellNav : $('.mx-shell-left-sidebar');

			if (mxShellNav[0]) {
				mxShellNav.css({
					'max-width': navWidthCss,
					'min-width': navWidthCss,
					width: navWidthCss,
					transition: useAnimation ? '' : 'initial',
				});

				cssHtml = '.mx-shell-left-nav-left-offset {' + 'left: ' + (vm.leftSidebarService.isVisible ? navWidthCss : '0') + ' !important;' + '}';

				if (_cssHtmlEl && _cssHtmlEl[0]) {
					_cssHtmlEl.html(cssHtml);
				} else {
					$('head').append('<style id="mx-shell-nav-styles">' + cssHtml + '</style>');
					_cssHtmlEl = $('#mx-shell-nav-styles');
				}
			}
			_debouncedLayoutChangeDispatcher();
		}

		function removeSizes() {
			$('#mx-shell-nav-styles').remove();
		}

		function onTabClick(panel) {
			leftSidebarService.showPanel(panel, true);
		}

		function registerHotkeys() {
			keyboardNavigationService.registerKey({
				callback: $.throttle(300, function () {
					$scope.$evalAsync(function () {
						vm.NavigationManager.collapsedMode = !vm.NavigationManager.collapsedMode;
					});
				}),
				description: i18n.get('shell.mx-shell-nav.toggleSidebar'),
				key: 'alt+/',
				nameInTemplate: 'sidebarHint',
				scope: $scope,
			});
		}

		function initAria() {
			setTimeout(() => $element.find('md-tabs-canvas, md-tab-item').attr('tabindex', '-1'), 500);
		}
	}
})();
